// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"1d68c342","769":"8970a935"}[chunkId] + ".chunk.css";
};